import { render } from "./Pingjia.vue?vue&type=template&id=40be9d15&scoped=true"
import script from "./Pingjia.vue?vue&type=script&lang=js"
export * from "./Pingjia.vue?vue&type=script&lang=js"

import "./Pingjia.vue?vue&type=style&index=0&id=40be9d15&lang=css"
import "./Pingjia.vue?vue&type=style&index=1&id=40be9d15&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40be9d15"]])

export default __exports__